import React from 'react';
import { useParams } from "react-router-dom";

import Auth from '../../Auth'
import { defineEnvironmentDokuWiki } from '../../helpers/labels'

const PatternsWikiLinks = (props) => {
	const params = useParams();
	const WIKI_URL = process.env.REACT_APP_dokuwikiLinks

	location.href = `https://${defineEnvironmentDokuWiki()}/${WIKI_URL[params.linkType]}?s_t=${new Auth().getSessionToken()}&env=${location.hostname}`

	return <div />
}

export default PatternsWikiLinks;
